import axios from 'axios';
import { tokenManager } from './tokenManager';
import { tokenRefreshManager } from './tokenRefreshManager';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'https://backend.adhdrapidcare.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add access token only
axiosInstance.interceptors.request.use(async (config) => {
    const token = tokenManager.getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});



// Response interceptor to handle 401 errors with immediate token refresh
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Check if error is 401 (token expired) and we haven't already tried to refresh
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            console.log('🔴 401 Unauthorized - Token expired, refreshing immediately...');

            try {
                // Immediately refresh the token
                await tokenRefreshManager.refreshTokenSilently();
                
                // Update authorization header for the original request with new token
                const newToken = tokenManager.getAccessToken();
                if (newToken) {
                    originalRequest.headers.Authorization = `Bearer ${newToken}`;
                    console.log('🔄 Retrying API call with refreshed token');
                    
                    // Retry the original request
                    return axiosInstance(originalRequest);
                } else {
                    throw new Error('No token available after refresh');
                }
                
            } catch (refreshError) {
                console.error('❌ Token refresh failed:', refreshError);
                tokenManager.clearTokens();
                // Only redirect to landing page if not on care-plan
                if (!window.location.pathname.includes('/care-plan')) {
                    window.location.href = '/';
                }
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;